import { NavLink } from 'react-router-dom';
import { useWhiteLabellingContext } from 'contexts/WhiteLabellingContext';
import './index.css';

const PageNotFound = ({
  heading = `Apologies, we couldn’t find the page you were looking for.`,
}) => {
  const { firm, isSubdomain } = useWhiteLabellingContext();

  return (
    <>
      <div className="container c-container">
        <div className="pg-wrp">
          <div className="page-not-fnd-container">
            <div className="page-not-fnd-title">
              <h3 className="ph-hed">{heading}</h3>

              {isSubdomain ? (
                firm?.investmentFirmLogo && (
                  <img
                    src={firm?.whiteLabelConfig?.whiteBgLogo?.url}
                    alt={firm?.firmName}
                    className="s-img ml-4"
                  />
                )
              ) : (
                <img
                  src="assets/images/invest-further.webp"
                  alt="further"
                  className="s-img ml-4"
                />
              )}
            </div>

            <br />
            <div className="lnk-cnt">
              <NavLink to="/" className="red-lnk">
                {isSubdomain ? 'Back to portal home' : 'Go to homepage'}
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PageNotFound;
